import { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

// Components
import { PageHeader } from "../components/PageSpecificComponents";
import { Body, Button, Card, CentralModal } from "../components/UI";
import ConfirmDialog from "../components/UI/ConfirmDialog/ConfirmDialog";
import { Paragraph } from "../components/typography";
import ManagerItem from "../components/lists/Managers/Manager.item";
import Row from "../components/lists/Row";

// Containers
import AddManager from "../containers/forms/managers/AddManager/AddManager";
import EditManager from "../containers/forms/managers/EditManager/EditManager";

// Builders
import * as buttonDesignType from "../builders/buttonDesign.types";
// Constants


// Actions
import {
  openModal,
  deleteManager,
  closeModal,
  getManagers,
  editManager
} from "../redux/actions/managers.actions";

// Styles
import { ManagersStyles } from "../pagesStyles/managers.styles";

const ADD_MANAGER = "ADD_MANAGER";
const EDIT_MANAGER = "EDIT_MANAGER";

const managersTableHead = [
  { className: "firstName", title: "First Name" },
  { className: "lastName", title: "Last Name" },
  { className: "permissions", title: "Permissions" },
  { className: "phone", title: "Phone" },
  { className: "email", title: "Email" }
];

const Managers = () => {
  const dispatch = useDispatch();
  const [managerToDelete, setManagerToDelete] = useState(null);
  const { managers, chosenManager, modalType } = useSelector(
    state => state.managersPage
  );

  useEffect(() => {
    dispatch(getManagers());
  }, [dispatch]);

  const confirmDeleteManager = () => {
    dispatch(deleteManager(managerToDelete));
    setManagerToDelete(null);
  };

  const editManagerHandler = useCallback(
    (manager, modalType) => dispatch(editManager(manager, modalType)),
    [dispatch]
  );

  const openModalHandler = useCallback(
    modalType => dispatch(openModal(modalType)),
    [dispatch]
  );

  const closeModalHandler = useCallback(
    () => dispatch(closeModal()),
    [dispatch]
  );

  return (
    <ManagersStyles>
      <PageHeader title="Managers">
        <Button
          onClick={() => openModalHandler(ADD_MANAGER)}
          buttonDesignType={buttonDesignType.PRIMARY}
        >
          + Add New Manager
        </Button>
      </PageHeader>
      <Card className="tableCard" rounded>
        <div className="tableScroll">
          <Body className="tableHead">
            {managersTableHead.map(({ title, className }, i) => (
              <Paragraph className={`tableHeadTitle ${className}`} key={i}>
                {title}
              </Paragraph>
            ))}
          </Body>
          {managers.map(item => (
            <Row
              key={item.id}
              className="managerRow"
              onClick={() => editManagerHandler(item, EDIT_MANAGER)}
              style={{ cursor: "pointer" }}
            >
              <ManagerItem
                item={item}
                deleteManager={() => setManagerToDelete(item.id)}
              />
            </Row>
          ))}
        </div>
      </Card>

      <CentralModal
        width={681}
        closeModal={closeModalHandler}
        isOpen={!!modalType}
      >
        <Card className="card">
          {modalType === ADD_MANAGER && (
            <AddManager closeModal={closeModalHandler} />
          )}
          {modalType === EDIT_MANAGER && chosenManager && (
            <EditManager closeModal={closeModalHandler} />
          )}
        </Card>
      </CentralModal>
      <ConfirmDialog
        isOpen={!!managerToDelete}
        onClose={() => setManagerToDelete(null)}
        onConfirm={confirmDeleteManager}
        title="Delete Manager?"
        message="Are you sure you want to delete this manager? This action cannot be undone."
      />
    </ManagersStyles>
  );
};

export default Managers;
